import React, { useCallback, useEffect, useState } from "react";

import PaidIcon from "@mui/icons-material/PaidOutlined";

import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { FilterContext, useFilter } from "../../components/Filter";
import {
    ListView,
    MainPage,
    MainView,
    PageContext,
    usePageState,
} from "../../components/PageLayout";
import { initPeriod } from "../../components/Period";
import { useSideSheet } from "../../components/SideSheet";
import { RecurringPaymentDialog, TransactionModal } from "../../modules/financials";
import { useUserInfo } from "../../utils/security";
import { FinancialsOverview } from "./FinancialsOverview";
import { FinancialsSpeedDial } from "./FinancialsSpeedDial";
import { fetchTransactionDetail, fetchTransactionList, fetchTransactionOverview } from "./mock";
import { FinancialsList } from "./TransactionsList";

export * from "./CurrencySettingsCard";
export * from "./TaxSettingsCard";
export * from "./TransactionTypesSettingsCard";
export * from "./FinancesSettingsForm";
export * from "./TransactionModal";
export * from "./RecurringPaymentDialog";

export const FinancialsIcon = PaidIcon;

export const FinancialsPage = ({ pagePath }) => {
    const navigate = useNavigate();
    const { id: detailId } = useParams();
    const sideSheet = useSideSheet();
    const { userInfo } = useUserInfo();

    console.log("detailId", detailId);

    const [recurringDialogOpen, setRecurringDialogOpen] = useState(false);

    const filterState = useFilter({
        filter: {
            period: initPeriod("year"),
        },
    });
    const { filterValue } = filterState;

    const pageState = usePageState();
    const { state, setListLoading, setList, setDataLoading, setData } = pageState;

    //TODO - implement functions TODO
    const addTransaction = useCallback(
        ({ id, name, ...rest }) => {
            sideSheet.show({
                transactionTypeId: id,
                transactionTypeName: name,
                date: dayjs(),
                fiscalYear: dayjs().year(),
                dueDate:
                    rest.hasDueDate && rest.defaultDueDateDays
                        ? dayjs().add(rest.defaultDueDateDays || 0, "days")
                        : undefined,
                currencyCode: userInfo?.defaultCurrency?.code || "CZK",
                ...(rest.hasSubjectInfo
                    ? {
                          subjectName: userInfo?.financesSettings?.name,
                          subjectAddress: userInfo?.financesSettings?.address,
                          subjectIdNumber: userInfo?.financesSettings?.idNumber,
                          subjectTaxIdNumber: userInfo?.financesSettings?.taxIdNumber,
                      }
                    : {}),
                ...rest,
            });
        },
        [sideSheet, userInfo]
    );

    const addRecurringTransaction = useCallback(
        ({ transactionType, ...recurringSettings }) => {
            addTransaction({
                ...transactionType,
                date: recurringSettings?.date,
                recurringSettings,
            });
        },
        [addTransaction]
    );

    const showRecurringDialog = () => {
        setRecurringDialogOpen(true);
    };

    useEffect(() => {
        const fetchList = async (filter) => {
            setListLoading(true);
            try {
                const data = await fetchTransactionList(filter);
                setList(data);
            } catch (e) {
                console.error(e);
                setList({ error: true });
            } finally {
                setListLoading(false);
            }
        };

        const fetchOverview = async (filter) => {
            setDataLoading(true);
            try {
                const data = await fetchTransactionOverview(filter);
                setData(data);
            } catch (e) {
                console.error(e);
                setList({ error: true });
            } finally {
                setDataLoading(false);
            }
        };

        fetchList(filterValue);
        fetchOverview(filterValue);
    }, [filterValue]);

    //fetch loaded data
    useEffect(() => {
        const fetchDetail = async (id) => {
            console.log("fetching detail", id);
            sideSheet.show({}, true);

            try {
                const data = await fetchTransactionDetail(id);
                sideSheet.show(data, false);
            } catch (e) {
                console.error(e);
                sideSheet.show({ error: true }, false);
            }
        };
        if (!isEmpty(detailId)) {
            fetchDetail(detailId);
        }
    }, [detailId, sideSheet.show, sideSheet.hide, fetchTransactionDetail]);

    return (
        <>
            <FilterContext.Provider value={filterState}>
                <PageContext.Provider value={pageState}>
                    <MainPage>
                        <ListView>
                            <FinancialsList
                                onAddTransaction={addTransaction}
                                onShowRecurringDialog={showRecurringDialog}
                                selectItem={({ id }) => navigate(`/${pagePath}/${id}`)}
                                loading={state.listLoading}
                                data={state.list}
                            />
                        </ListView>
                        <MainView>
                            <FinancialsOverview
                                onAddTransaction={addTransaction}
                                onShowRecurringDialog={showRecurringDialog}
                                loading={state.dataLoading}
                                data={state.data}
                            />
                        </MainView>
                    </MainPage>
                </PageContext.Provider>
            </FilterContext.Provider>
            <FinancialsSpeedDial
                onAddTransaction={addTransaction}
                onShowRecurringDialog={showRecurringDialog}
            />
            <TransactionModal
                open={sideSheet.open}
                data={sideSheet.data}
                hide={() => {
                    sideSheet.hide();
                    navigate(`/${pagePath}`);
                }}
                onTransactionSaved={async (data) => {
                    //await saveTransaction(data);
                    sideSheet.hide();
                    //selectItem();
                }}
                dataLoading={sideSheet.loading}
            />
            <RecurringPaymentDialog
                open={recurringDialogOpen}
                onClose={() => setRecurringDialogOpen(false)}
                onSubmit={(data) => {
                    addRecurringTransaction(data);
                    setRecurringDialogOpen(false);
                }}
                data={{
                    date: dayjs().format("YYYY-MM-DD"),
                    frequency: "month",
                    count: 12,
                }}
            />
        </>
    );
};
